import TourTooltip from 'elements/tooltip/TourTooltip'
import { TourConfigType } from 'persistentContent/tours/types'
import { useTranslate } from 'ra-core'
import { FC } from 'react'

const StepTooltip: FC = (props) => {
  const translate = useTranslate()
  return (
    <TourTooltip
      title={translate('Actions Management')}
      subtext={translate(
        'Efficiently oversee actions in your workflow. View here the Actions relevant to your current project stage, and stay on top of crucial actions to complete.'
      )}
      {...props}
    />
  )
}

const Actions: TourConfigType = {
  spotlights: [{ targetId: 'Project-Actions-Section', autoScroll: true }],
  tooltips: [
    {
      targetId: 'Project-Actions-Section',
      placement: 'bottom-start',
      component: StepTooltip,
      options: { accountScroll: true },
    },
  ],
}

export default Actions
